import { render, staticRenderFns } from "./TsTesLogo.vue?vue&type=template&id=64a28a6e&functional=true"
import script from "./TsTesLogo.vue?vue&type=script&lang=js"
export * from "./TsTesLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports